import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface HeroSectionProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function HeroSection({ onOpenWhatsApp }: HeroSectionProps) {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[800px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20commercial%20kitchen%20with%20multiple%20chefs%20preparing%20large%20quantities%20of%20fresh%20Turkish%20food%20in%20stainless%20steel%20trays%20hot%20meals%20rice%20meat%20vegetables%20bright%20hygienic%20professional%20lighting%20wide%20angle%20editorial%20photography&width=1600&height=900&seq=hero-kaya-1&orientation=landscape"
          alt="Kaya Catering profesyonel mutfak"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-accent-950/80 via-accent-950/70 to-accent-950/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 max-w-5xl mx-auto text-center pt-16 md:pt-20">
        <div className="reveal mb-4">
          <span className="inline-block px-4 py-1.5 bg-primary-500/20 border border-primary-500/30 rounded-full text-primary-400 font-label text-xs font-medium tracking-wide">
            TOPLU YEMEKTE PROFESYONEL ÇÖZÜM ORTAĞINIZ
          </span>
        </div>
        <h2 className="reveal font-heading text-5xl md:text-7xl lg:text-8xl text-background-50 leading-tight mb-6">
          TOPLU YEMEKTE
          <br />
          PROFESYONEL ÇÖZÜM
        </h2>
        <p className="reveal text-background-200 font-body text-base md:text-lg max-w-2xl mx-auto mb-4">
          Fabrika, şantiye, şirket, okul, film/dizi seti ve organizasyonlara
          ihtiyaca özel catering hizmeti.
        </p>
        <p className="reveal text-primary-400 font-label text-sm md:text-base font-semibold mb-8">
          Kaç kişilik yemek hizmetine ihtiyacınız var?
        </p>
        <div className="reveal flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => onOpenWhatsApp()}
            className="btn-primary text-base px-8 py-4"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WHATSAPP&apos;TAN TEKLİF AL
          </button>
          <a
            href="#hizmetler"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-background-300/60 text-background-100 font-label font-semibold text-base rounded-md whitespace-nowrap transition-all duration-300 hover:bg-background-100/10"
          >
            Hizmetleri İncele
          </a>
        </div>
        <p className="reveal text-background-400/80 font-label text-xs mt-6 max-w-xl mx-auto">
          Kişi sayınızı ve hizmet bölgenizi iletin, ihtiyacınıza uygun teklifimizi
          hazırlayalım.
        </p>
      </div>
    </section>
  );
}